import type { NuxtApp } from '#app'

type AsyncDataCacheContext = {
  cause?: 'initial' | 'refresh:manual' | 'refresh:hook' | 'refresh:watch' | 'watch' | string
}

/**
 * Opciones de fetch que evitan datos stale por `static.data` / payload de ruta en navegaciones cliente,
 * sin romper la hidratación: en el cliente, mientras `isHydrating`, se reutiliza `payload.data[key]` como hace Nuxt por defecto.
 *
 * @see https://nuxt.com/docs/4.x/getting-started/data-fetching#caching-and-refetching
 */
export function useNoCacheFetchOptions() {
  return {
    cache: 'no-store' as const,
    getCachedData: (key: string, nuxtApp: NuxtApp, ctx: AsyncDataCacheContext) => {
      if (nuxtApp.isHydrating) {
        return nuxtApp.payload.data[key]
      }
      if (ctx.cause === 'refresh:manual' || ctx.cause === 'refresh:hook') {
        return undefined
      }
      return undefined
    }
  }
}
